<template>
    <v-layout row wrap>
        <v-flex xs6 class="pr-0">
            <v-btn
                :color="value ? 'secondary' : undefined"
                block
                depressed
                class="br-0"
                :outline="!value"
                :to="{name: 'checkout', params: {stepName: rootStep}}"
                large
                active-class=""
            >
                {{ 'New customer' | translation }}
            </v-btn>
        </v-flex>

        <v-flex xs6 class="pl-0">
            <v-btn
                :color="!value ? 'secondary' : undefined"
                block
                depressed
                class="br-0"
                :outline="value"
                :to="{name: 'checkout', params: {stepName: rootStep, subStepName: routes.registered}}"
                large
            >
                {{ 'Login' | translation }}
            </v-btn>
        </v-flex>
    </v-layout>
</template>

<script>
import AbstractRouteSwitcher from './AbstractRouteSwitcher';

export default {
    name: 'RegistrationLoginSwitcher',
    extends: AbstractRouteSwitcher,
    props: {
        value: Boolean,
    },
    data() {
        return {
            routes: {
                registered: 'registered',
            },
            values: {
                registered: false,
            },
        };
    },
    created() {
        if (this.$session.get('registration-login-switcher') !== undefined) {
            this.$emit('input', this.$session.get('registration-login-switcher'));
        }
    },
    watch: {
        value(value) {
            if (value !== undefined && value !== null) {
                this.$session.set('registration-login-switcher', value);
                if (
                    value === false &&
                    (!this.$route.params.subStepName || this.routes.registered !== this.$route.params.subStepName)
                ) {
                    this.$router.push({
                        name: 'checkout',
                        params: { stepName: this.rootStep, subStepName: this.routes.registered },
                    });
                }
            } else {
                this.$session.remove('registration-login-switcher');
            }
        },
        '$vuetify.breakpoint.mdAndUp'(val) {
            if (val) {
                this.$emit('input', this.defaultValue);
                this.$session.remove('registration-login-switcher');
            }
        },
    },
};
</script>
